import { StoreHeader } from '../components/StoreHeader';
import { StoreFooter } from '../components/StoreFooter';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-stone-100">
      <StoreHeader />

      <main className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-stone-900 mb-6">Privacy Policy</h1>

        <div className="space-y-6 text-stone-700 text-sm leading-relaxed">
          <p>
            At Megamart Online Shopping, we value your privacy and are committed to protecting your personal information.
            This Privacy Policy outlines how we collect, use, and safeguard your data when you interact with our website and services.
          </p>

          <h2 className="text-xl font-semibold text-stone-900">1. Information We Collect</h2>
          <ul className="list-disc pl-6">
            <li>Personal details such as name, email address, phone number, and delivery address.</li>
            <li>Order history, cart contents, and payment details (processed securely via third-party providers).</li>
            <li>Device and browser information, IP address, and usage data for analytics and performance.</li>
          </ul>

          <h2 className="text-xl font-semibold text-stone-900">2. How We Use Your Information</h2>
          <ul className="list-disc pl-6">
            <li>To process orders, payments, and deliveries.</li>
            <li>To send order updates via email, SMS, or WhatsApp.</li>
            <li>To improve our website, services, and customer experience.</li>
            <li>To comply with legal obligations and prevent fraud.</li>
          </ul>

          <h2 className="text-xl font-semibold text-stone-900">3. Data Sharing & Third Parties</h2>
          <p>
            We do not sell your personal data. We may share information with trusted third-party services for payment processing,
            delivery logistics, and communication (e.g., WhatsApp Cloud API). All partners are vetted for compliance and security.
          </p>

          <h2 className="text-xl font-semibold text-stone-900">4. Cookies & Tracking</h2>
          <p>
            Our site uses cookies to remember your preferences, track cart activity, and analyze traffic.
            You can manage cookie settings in your browser.
          </p>

          <h2 className="text-xl font-semibold text-stone-900">5. Your Rights</h2>
          <ul className="list-disc pl-6">
            <li>Access, update, or delete your personal data by contacting our support team.</li>
            <li>Opt out of marketing communications at any time.</li>
          </ul>

          <h2 className="text-xl font-semibold text-stone-900">6. Data Security</h2>
          <p>
            We implement industry-standard security measures to protect your data, including HTTPS encryption,
            secure payment gateways, and restricted access controls.
          </p>

          <h2 className="text-xl font-semibold text-stone-900">7. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Changes will be posted on this page with a revised date.
          </p>

          <p>
            If you have any questions or concerns about your privacy, please contact us at <strong>support@megamart.co.ke</strong>.
          </p>
        </div>
      </main>

      <StoreFooter />
    </div>
  );
}
